<template>
	<div class="w-100 p-3 bg-white border-15 overflow-auto">
		<table class="table">
			<tr class="border">
				<td class="bMikhak p-3 text-center">
					کاربر
				</td>
				<td class="bMikhak p-3 text-center">
					نظر
				</td>
				<td class="bMikhak p-3 text-center">
					بررسی کننده
				</td>
				<td class="bMikhak p-3 text-center">
					وضعیت
				</td>
				<td class="bMikhak p-3 text-center" colspan="2">
					مدیریت
				</td>
			</tr>
			<tr v-for="(f, i) in flds.content" :key="i">
				<td class="text-center">
					{{f.fullname}}
					<br>
					<span class="text-orange">
						{{f.knd_user}}
					</span>
				</td>
				<td style="max-width: 400px;" :title="f.comment_user">
					<div class="text-truncate">
						{{f.comment_user}}
					</div>
				</td>
				<td class="text-center">
					{{f.admin}}
					<br v-if="f.admin" />
					<span class="text-orange">
						{{f.admin_date}}
					</span>
				</td>
				<td class="text-center text-danger" v-if="f.status==0">
					غیر فعال
				</td>
				<td class="text-center text-success" v-if="f.status==1">
					فعال
				</td>
				<td class="text-center">
					<router-link
					:to="'/reserved/user/'+f.reserved"
					class="text-danger"
					style="font-size: 14px;"
					>
						نمایش
					</router-link>
				<td class="text-center text-primary pointer" style="font-size: 14px;" @click="show_comment(i)">
					بررسی
				</td>
			</tr>
		</table>
		<br/>
		<br/>
		<div class="w-100" style="display: flex; align-items: center; justify-content: center;">
			<pageNavigation :page="flds.curPage" :pages="flds.totalPages" @setPage="setPage"  />
		</div>
	</div>
</template>

	<script>
		import btn from  "../../UI/button/btn.vue";
		import userImg from  "../../UI/userImg/userImg.vue";
		import pageNavigation from  "../../UI/pageNavigation/pageNavigation.vue";
		import { success } from  "../../assets/library/messege.js";

		export default {
			name: 'teachers_part1',
			data(){
				return {
					success: success
				}
			},
			components: {
				btn,
				pageNavigation,
				userImg,
			},
			props: {
				flds: {
					default: [],
				},
			},
			mounted(){

			},
			methods:{
				show_comment(i){
					var data = this.flds.content[i];
					this.$swal.fire({
						position: 'center',
						type: '',
						title: "بررسی نظر",
						html: "<div class='text-justify'>"+data.comment_user+"</div>",
						showCloseButton: true,
						showConfirmButton: true,
						showCancelButton: true,
						confirmButtonText: "تایید",
						cancelButtonText: "رد",
						confirmButtonClass:"btn btn-outline-success border w-50",
						cancelButtonClass:"btn btn-danger w-50",
					}).then((result) => {
						if(result.value){
							this.setStatus(data.id, 1, (data.admin_date==null))
						}
						if(result.dismiss== 'cancel'){
							this.setStatus(data.id, 0, (data.admin_date==null))
						}
					})
				},
				//****************************************************** */
				setStatus(id, status, new_comment, THIS=this){
					window.$.post(window.baseurl + 'reserved/'+id , {
						status: status,
						token: this.$localStorage.get("user"),
						mode: "set_status_comment",
						new: new_comment,

					}, function (D) {
						THIS.success(THIS)
						THIS.$emit('setPage', THIS.$route.query.page);
					}, "json");
				},
				//****************************************************** */
				setPage(page){
					this.$emit('setPage', page);
				}
			}
		}
	</script>
<style scoped>
tr:nth-child(odd){
	background-color:#fff !important;
}
tr:nth-child(even){
	background-color: #F5FAFD !important;
}
</style>
